import { useEffect, useState } from "react";
import { useParams, Link, useSearchParams } from "react-router-dom";
import axios from "axios";
import { API, useAuth } from "../App";
import { CheckCircle2, Sparkles } from "lucide-react";
import { Button } from "../components/ui/button";

export default function OrderSuccess() {
  const { id } = useParams();
  const [params] = useSearchParams();
  const guestEmail = params.get("email");
  const { user } = useAuth();
  const [order, setOrder] = useState(null);

  useEffect(() => {
    const url = user
      ? `${API}/orders/${id}`
      : `${API}/orders/guest/${id}?email=${encodeURIComponent(guestEmail || "")}`;
    axios.get(url).then(r => setOrder(r.data)).catch(() => {});
  }, [id, user, guestEmail]);

  const isGuest = !user;
  return (
    <div className="max-w-2xl mx-auto px-4 py-20 text-center" data-testid="order-success-page">
      <div className="inline-flex items-center justify-center h-20 w-20 rounded-full bg-[#FFF5F3] mb-6">
        <CheckCircle2 className="h-10 w-10 text-[#2E7D32]" />
      </div>
      <p className="label-small text-[#C5A059] mb-3">Order Confirmed</p>
      <h1 className="font-display text-4xl sm:text-5xl text-[#2C2A29]" data-testid="order-success-title">Thank you for shopping with Sumanya</h1>
      <p className="text-[#595552] mt-4">Your order <span className="font-semibold text-[#8B1E28]" data-testid="order-id">{id}</span> has been placed.</p>
      {isGuest && guestEmail && (
        <p className="text-sm text-[#8A8480] mt-2" data-testid="guest-email-note">
          We&rsquo;ve emailed the receipt to <span className="text-[#2C2A29] font-medium">{guestEmail}</span>.
        </p>
      )}
      {order && (
        <div className="mt-8 bg-white border border-[#EAE3D9] rounded-2xl p-6 text-left">
          <div className="flex items-center gap-2 text-xs text-[#C5A059] mb-3">
            <Sparkles className="h-3 w-3" /> <span>Hand-packed with love</span>
          </div>
          <div className="space-y-3">
            {order.items.map((it, i) => (
              <div key={i} className="flex gap-3 items-center">
                <img src={it.image} alt="" className="h-14 w-14 rounded-lg object-cover bg-[#FFF5F3]" />
                <div className="flex-1 text-sm">
                  <div>{it.name}</div>
                  <div className="text-xs text-[#8A8480]">Qty {it.quantity}{it.size ? ` · ${it.size}` : ""}</div>
                </div>
                <div className="text-sm font-semibold">₹{(it.price * it.quantity).toLocaleString("en-IN")}</div>
              </div>
            ))}
          </div>
          <div className="border-t border-[#EAE3D9] mt-4 pt-3 flex justify-between font-semibold">
            <span>Total paid</span>
            <span className="text-lg text-[#8B1E28]">₹{order.total.toLocaleString("en-IN")}</span>
          </div>
        </div>
      )}
      <div className="flex gap-3 mt-8 justify-center">
        {!isGuest && <Link to="/orders"><Button className="btn-primary rounded-full px-6 py-5 h-auto" data-testid="view-orders-btn">View my orders</Button></Link>}
        <Link to="/products"><Button variant="outline" className="rounded-full px-6 py-5 h-auto border-[#C5A059] text-[#8B1E28]">Continue shopping</Button></Link>
      </div>
    </div>
  );
}
